import { useEffect, useState } from 'react';

interface Timeout {
  enter: number;
  exit: number;
}

export const useSlideAnimation = (prefix: string, timeout: Timeout) => {
  const [classes, setClasses] = useState<string>('');

  const clear = () => {
    setClasses('');
  };

  const enter = () => {
    setClasses(`${prefix}-enter`);
  };

  const enterActive = () => {
    setClasses(`${prefix}-enter ${prefix}-enter-active`);
  };

  const exit = () => {
    setClasses(`${prefix}-exit`);
  };

  const exitActive = () => {
    setClasses(`${prefix}-exit ${prefix}-exit-active`);
  };

  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    enter();
    setTimeout(enterActive, 0);
    setTimeout(clear, timeout.enter);

    return () => {
      exit();
      setTimeout(exitActive, 0);
      setTimeout(clear, timeout.exit);
    };
  }, []);

  return classes;
};
